module.exports = __webpack_public_path__ + "img/12.fb1966a7.jpg";